const url = "config/" + window.location.hostname + "_config.json";

let config = '';
let urlSlug = localStorage.getItem("urlSlug");
let token_sso = localStorage.getItem("token_api_sso");
let api_sso = '';
let api_clube = '';

async function fetchAndConfig() {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const jsonData = await response.json();
    config = jsonData;
    localStorage.setItem(window.location.hostname, JSON.stringify(jsonData));
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
    throw error;
  }
}

export async function initialize() {
  try {
    if(!config) {
      await fetchAndConfig();
    }

    urlSlug = localStorage.getItem("urlSlug");

    api_sso = config ? config.CONFIG_API.find((item) => item.api === "API_SSO" && item.url_slug === urlSlug) : {};
    api_clube = config ? config.CONFIG_API.find((item) => item.api === "API_CLUBE" && item.url_slug === urlSlug) : {};
    token_sso = localStorage.getItem("token_api_sso");
    return  { api_sso, api_clube, token_sso }
  } catch (error) {
    console.error('There was a problem with the initialize:', error);
    throw error;
  }
}
